// External libraries
import React from 'react';
import styled from 'styled-components';

// Icon code
import { Icon } from './_base';

const VideoSVG = styled(Icon).attrs({ viewBox: '0 0 163.67 97' })`
    width: 1.667em;
`;

const Video = props => (
    <VideoSVG xmlns="http://www.w3.org/2000/svg" {...props}>
        <polygon
            fill="none"
            points="118 36.19 118 61.39 118 61.39 157.67 77.51 157.67 48.54 157.67 19.57 118 36.19 118 36.19"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeWidth="12px"
        />
        <rect
            fill="none"
            height="85"
            stroke="currentcolor"
            strokeMiterlimit="10"
            strokeWidth="12px"
            width="112"
            x="6"
            y="6"
        />
    </VideoSVG>
);

export { Video as default, Video };
